/*********************** Custom JS for Boost AI Search & Discovery  ************************/
function buildSwatchColor(imageUrl, colorCodes, type) {
    var backgroundColor = '';
    var backgroundImage = '';
    var background = '';
    switch (type) {
        case 'one_color':
            if (colorCodes.length > 0 && colorCodes[0]) {
                backgroundColor = colorCodes[0];
                backgroundImage = '""';
            }
            break;
        case 'two_colors':
            if (colorCodes.length > 1 && colorCodes.colorCodes[0] && colorCodes.colorCodes[1]) {
                backgroundImage = 'linear-gradient(to top left, ' + colorCodes.colorCodes[1] + ' 50%, ' + colorCodes[0] + ' 50%);';
                backgroundColor = 'transparent';
            }
            break;
        case 'image':
            if (imageUrl) {
                backgroundImage = 'url(' + imageUrl + ');';
                backgroundColor = buildSwatchColor(null, colorCodes, type); // Fallback color for image
            }
            break;
    }
    background = 'background-color: ' + backgroundColor + '; background-image: ' + backgroundImage + ';';
    return background;
}

function getVariantColor(variantId, data) {
    var metafields = data.metafields;
    for (var i = 0; i < metafields.length; i++) {
        if (metafields[i].key == 'collection_swatch' && metafields[i].id == variantId) {
            return metafields[i].value;
        }
    }
    return '';
}

function checkVariantBaseLocation(variant) {
    var selectedLocation = Globals.queryParams['pf_vl_locations'];
    if (typeof(selectedLocation) !== 'undefined' && selectedLocation !== null && selectedLocation.length > 0 && variant.inventory_quantities) {
        var locationInventory = 0;
        for (var i = 0; i < selectedLocation.length; i++) {
            locationInventory = locationInventory + variant.inventory_quantities[selectedLocation[i]];
        }
        if (locationInventory > 0) {
            return true;
        } else {
            return false;
        }
    }
    return true;
}

function buildSwatch(data) {
    var html = '';
    var values = [];
    var swatchItems = [];
    var swatchSettings = Settings.getSettingValue('swatch_settings');
    //if (boostPFSConfig.custom.collection_swatches) {
    data.variants.forEach(function(variant) {
        var colorValue = '';
        var optionValue = '';
        // Fix boost #203230
        if (variant.original_merged_options) {
            variant.original_merged_options.forEach(function(option) {
                // End #203230
                var key = option.split(':')[0];
                var value = option.split(':')[1];
                if ((key.toLowerCase().indexOf('color') != -1 || key.toLowerCase().indexOf('colour') != -1) && values.indexOf(value.toLowerCase()) == -1) {
                    values.push(value.toLowerCase());
                    colorValue = value;
                    optionValue = key;
                }
            });
        } else {
            variant.merged_options.forEach(function(option) {
                // End #203230
                var key = option.split(':')[0];
                var value = option.split(':')[1];
                if ((key.toLowerCase().indexOf('color') != -1 || key.toLowerCase().indexOf('colour') != -1) && values.indexOf(value.toLowerCase()) == -1) {
                    values.push(value.toLowerCase());
                    colorValue = value;
                    optionValue = key;
                }
            });
        }
        var lwSwatchName = colorValue.toLowerCase();
        var crColorSetting = swatchSettings['filter:color_' + lwSwatchName];
        if (crColorSetting) {
            var ctBackground = buildSwatchColor(crColorSetting.imageUrl, crColorSetting.colorCodes, crColorSetting.type);
        } else {
            var ctBackground = '';
        }
        if (getVariantColor(variant.id, data) !== '') {
            ctBackground = "background-color:" + getVariantColor(variant.id, data) + ";";
        }
        if (checkVariantBaseLocation(variant) && colorValue) {
            var fImage = data.images_info[0];
            var fImageSrc = '';
            if (fImage && typeof(fImage.src) !== 'undefined' && fImage.src !== '') {
                fImageSrc = fImage.src;
            }
            var swatchItem = '<span class="swatch-custom swatch-color" data-url="' + Utils.buildProductItemUrlWithVariant(data) + '?variant=' + variant.id + '" data-color="' + colorValue + '" data-image="{{variantImage}}" data-old-image="' + fImageSrc + '" style="' + ctBackground + '">' +
                //'<img class="swatch__image" src="{{colorImage}}" onerror="this.className += \' swatch__image--empty\'">' +
                '</span>';
            swatchItem = swatchItem.replace(/{{swatchShape}}/g, 'circle');
            swatchItem = swatchItem.replace(/{{colorBackground}}/g, Utils.slugify(colorValue).split('-').pop());
            swatchItem = swatchItem.replace(/{{slugifyOptionValue}}/g, Utils.slugify(optionValue).replace('-', '_'));
            swatchItem = swatchItem.replace(/{{slugifyColorValue}}/g, Utils.slugify(colorValue).replace('-', '_'));
            swatchItem = swatchItem.replace(/{{variantUrl}}/g, Utils.buildProductItemUrl(data) + '?variant=' + variant.id);
            var colorImage = boostPFSAppConfig.general.file_url.split('?')[0] + Utils.slugify(colorValue) + '_50x.png';
            //swatchItem = swatchItem.replace(/{{colorImage}}/g, colorImage);
            var variantImage = '';
            var noImageClass = '';
            if (variant.image) {
                variantImage = Utils.optimizeImage(variant.image, '400x');
            }
            swatchItem = swatchItem.replace(/{{colorImage}}/g, Utils.optimizeImage(variant.image, '25x25'));
            swatchItem = swatchItem.replace(/{{variantImage}}/g, variantImage);
            swatchItems.push(swatchItem);
        }
    })
    //}
    if (swatchItems.length > 1) {
        html = `<div class="product-available" style="width: 100%;text-align: center;font-family: 'TTCommons_Regular';">Available in :</div><div class="product-grid-swatch-wrapper">${swatchItems.join(' ')}</div>`;
    }
    return html;
}
console.log('check Boost JS')
let formatMoneyHelper = '';
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useComponentPlugin('FormatCurrency', {
            name: 'Show Trailing Zeros',
            apply: () => ({
                afterRender: (element) => {
                    try {
                        formatMoneyHelper = element.getHelpers().formatMoney;
                        if (!formatMoneyHelper) return;
                    } catch (e) {
                        console.warn(e);
                    }
                },
            }),
        });
        componentRegistry.useComponentPlugin("Slider", {
            name: "Recommendation",
            enabled: true,
            apply: () => ({
                props(props) {
                    for (let i = 0; i < props.slides.length; i++) {
                        const original_images = props.slides[i].images_info;
                        props.slides[i].images_info[0] = original_images[1];
                        props.slides[i].images_info[1] = original_images[2];
                    }
                    return props;
                },
                afterRender(element) {
                    try {
                        let products = element.getParams().props.slides;
                        for (let i = 0; i < products.length; i++) {
                            let data = products[i];
                            let recommendationEls = document.querySelectorAll('.boost-sd__recommendation');
                            let existCondition = setInterval(function() {
                                if (recommendationEls.length > 0) {
                                    clearInterval(existCondition);
                                    let productItems = document.querySelectorAll(`.boost-sd__recommendation .boost-sd__product-item[data-product-id="${data.id}"]`);
                                    productItems.forEach(function(el) {
                                        // Update Swatch
                                        let swatchHTML = buildSwatch(data);
                                        el.querySelector('.boost-sd__product-info').insertAdjacentHTML('beforeend', swatchHTML);
                                        jQuery(function($) {
                                            $('.product-grid-swatch-wrapper .swatch-color').on('mouseenter mouseleave', function(evt) {
                                                let variantImage = $(this).data('image');
                                                let variantURL = $(this).data('url');
                                                let variantOldImage = $(this).data('old-image');
                                                $('.product-grid-swatch-wrapper .swatch-color').removeClass('active');
                                                $(this).addClass('active');
                                                $(this).closest('.boost-sd__product-item').find('a').attr('href', variantURL);
                                                if (evt.type === 'mouseenter') {
                                                    $(this).closest('.boost-sd__product-item').find('.boost-sd__product-image-img').attr('src', variantImage);
                                                    $(this).closest('.boost-sd__product-item').find('.boost-sd__product-image-img').attr('srcset', variantImage);
                                                } else {
                                                    //$(this).closest('.boost-sd__product-item').find('.boost-sd__product-image-img').attr('src',variantOldImage);
                                                }
                                            });
                                        });

                                        /* Boost-647868 */
                                        // Customize elements based on user login
                                        if (boostSDCustomData) {
                                            if (boostSDCustomData?.user?.tags !== null) {
                                                const customerTags = boostSDCustomData.user.tags;
                                                if (customerTags.includes('Wholesale') || customerTags.includes('wholesale')) {
                                                    const findVariantMetafield = data.metafields.filter(function(e) {
                                                        return e?.id == data.variants[0]['id'] && e.namespace == 'customAttributes' && e.key == 'wholesale_price';
                                                    });
                                                    if (typeof findVariantMetafield[0] !== 'undefined') {
                                                        const newPrice = formatMoneyHelper(Number(findVariantMetafield[0]['value']));
                                                        let newPriceHtml = '';
                                                        const priceStyle = 'color: ' + boostSDAppConfig.themeSettings.productItems.productInfo.elements.price.priceColor +
                                                                              '; font-size: ' + boostSDAppConfig.themeSettings.productItems.productInfo.elements.price.priceFontSize + 'px' +
                                                                              '; font-family: ' + boostSDAppConfig.themeSettings.productItems.productInfo.elements.price.priceFontFamily +
                                                                              '; font-weight: ' + boostSDAppConfig.themeSettings.productItems.productInfo.elements.price.priceFontWeight +
                                                                              '; font-style: ' + boostSDAppConfig.themeSettings.productItems.productInfo.elements.price.priceFontStyle;
                                                        newPriceHtml = '<span class="boost-sd__format-currency boost-sd__format-currency--price-sale">' +
                                                                            '<span style="' + priceStyle + '" class="">' + newPrice + '</span>' + 
                                                                        '</span>';

                                                        if (newPriceHtml !== '' && el.querySelector('.boost-sd__product-price .boost-sd__product-price-content')) {
                                                            el.querySelector('.boost-sd__product-price .boost-sd__product-price-content').innerHTML = newPriceHtml;
                                                        }
                                                    }
                                                } else if (customerTags.includes('Shipping') || customerTags.includes('shipping')) {
                                                    const findVariantMetafield = data.metafields.filter(function(e) {
                                                        return e?.id == data.variants[0]['id'] && e.namespace == 'customAttributes' && e.key == 'shipping_included_price';
                                                    });
                                                    if (typeof findVariantMetafield[0] !== 'undefined') {
                                                        const newPrice = formatMoneyHelper(Number(findVariantMetafield[0]['value']));
                                                        let newPriceHtml = '';
                                                        const priceStyle = 'color: ' + boostSDAppConfig.themeSettings.productItems.productInfo.elements.price.priceColor +
                                                                              '; font-size: ' + boostSDAppConfig.themeSettings.productItems.productInfo.elements.price.priceFontSize + 'px' +
                                                                              '; font-family: ' + boostSDAppConfig.themeSettings.productItems.productInfo.elements.price.priceFontFamily +
                                                                              '; font-weight: ' + boostSDAppConfig.themeSettings.productItems.productInfo.elements.price.priceFontWeight +
                                                                              '; font-style: ' + boostSDAppConfig.themeSettings.productItems.productInfo.elements.price.priceFontStyle;
                                                        newPriceHtml = '<span class="boost-sd__format-currency boost-sd__format-currency--price-sale">' +
                                                                            '<span style="' + priceStyle + '" class="">' + newPrice + '</span>' + 
                                                                        '</span>';

                                                        if (newPriceHtml !== '' && el.querySelector('.boost-sd__product-price .boost-sd__product-price-content')) {
                                                            el.querySelector('.boost-sd__product-price .boost-sd__product-price-content').innerHTML = newPriceHtml;
                                                        }
                                                    }
                                                } else {
                                                    const priceElement = el.querySelector('.boost-sd__product-price');
                                                    if (priceElement) {
                                                        priceElement.remove();
                                                    }
                                                    // const atcElement = el.querySelector('.boost-sd__button');
                                                    // if (atcElement) {
                                                    //     atcElement.remove();
                                                    // }
                                                }
                                            } else {
                                                const priceElement = el.querySelector('.boost-sd__product-price');
                                                if (priceElement) {
                                                    priceElement.remove();
                                                }
                                                // const atcElement = el.querySelector('.boost-sd__button');
                                                // if (atcElement) {
                                                //     atcElement.remove();
                                                // }
                                            }
                                        }
                                        /* Boost-647868 */
                                    });
                                }
                            }, 500);
                        }
                    } catch (error) {
                        // console.log(error);
                    }
                }
            }),
        });
    }
]);